import { PageWithAppBar } from '$common/page-with-app-bar'
import { AppBarBackTitle } from '$common/app-bar/app-bar-back-title'
import { closeActiveDevices } from '$logic/router'
import { t } from '$i18n'
import { SessionsList } from './sessions-list'

export function ActiveSessions() {
  return (
    <PageWithAppBar
      appBar={
        <AppBarBackTitle
          title={t('settings.sections.security.activeDevices')}
          onBack={closeActiveDevices}
        />
      }
    >
      <SessionsList
        onTerminateOtherSessions={() =>
          analite('PROFILE_SETTING_DEACTIVE_ALL_SESSIONS')
        }
        onTerminateSession={() =>
          analite('PROFILE_SETTING_DEACTIVE_ONE_SESSION')
        }
      />
    </PageWithAppBar>
  )
}
